export default __webpack_public_path__ + "static/media/20210501_000013-min.c8735d41.jpg";